class CartTool extends HTMLElement {
  constructor() {
    super();

    const buttons = this.querySelectorAll('.cartTool-item');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.popup;

        if (!id) return;

        const popup = document.getElementById(id);

        if (!popup) {
          console.error('Popup not found:', id);
          return;
        }

        // Close other popups
        document
          .querySelectorAll('.popup-toolDown.show')
          .forEach((item) => {
            item.classList.remove('show');
          });

        // Open selected popup
        popup.classList.add('show');

        const previewCart = document.querySelector('.previewCart');

        if (previewCart) {
          previewCart.classList.add('active-tool');
        }

        // Initialize shipping after popup opens
    if (id === 'popup-tool-shipping') {

  setTimeout(function() {

    /*
     * Load country states
     */
    const countrySelect =
      document.getElementById('address_country');

    if (
      countrySelect &&
      typeof window.updateCartDrawerProvinces === 'function'
    ) {

      window.updateCartDrawerProvinces(
        countrySelect
      );

    }

    /*
     * Start old Halo calculator
     */
    if (
      typeof window.initOldShippingCalculator === 'function'
    ) {

      window.initOldShippingCalculator();

    }

  }, 300);

}

        // Restore saved discount
        if (id === 'popup-tool-discount') {
          const input = popup.querySelector('input[name="discount"]');

          if (input) {
            input.value = localStorage.getItem('storedDiscount') || '';
          }
        }
      });
    });
  }
}

if (!customElements.get('cart-item-tool')) {
  customElements.define('cart-item-tool', CartTool);
}


/* =========================================================
   CANCEL POPUP
========================================================= */

class CartCancel extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('click', () => {
      const popup = this.closest('.popup-toolDown');

      if (popup) {
        popup.classList.remove('show');
      }

      const previewCart = document.querySelector('.previewCart');

      if (previewCart) {
        previewCart.classList.remove('active-tool');
      }
    });
  }
}

if (!customElements.get('cart-cancel-popup')) {
  customElements.define('cart-cancel-popup', CartCancel);
}


/* =========================================================
   CART NOTE
========================================================= */

class CartNote extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[data-update-note]');
    const textarea = this.querySelector('.text-area');

    if (!button || !textarea) return;

    button.addEventListener('click', async () => {
      const note = textarea.value;

      try {
        await fetch(routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            note: note
          })
        });

        const popup = this.closest('.popup-toolDown');

        if (popup) {
          popup.classList.remove('show');
        }

        const previewCart = document.querySelector('.previewCart');

        if (previewCart) {
          previewCart.classList.remove('active-tool');
        }

      } catch (error) {
        console.error('Cart note error:', error);
      }
    });
  }
}

/*
 * IMPORTANT:
 * Your theme already defines cart-note.
 * This prevents the "cart-note has already been used" error.
 */
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}


/* =========================================================
   COUPON CODE
========================================================= */

class CouponCode extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[name="discount"]');
    const button = this.querySelector('[data-update-coupon]');

    if (!input || !button) return;

    // Restore saved discount
    const savedDiscount = localStorage.getItem('storedDiscount');

    if (savedDiscount) {
      input.value = savedDiscount;
    }

    button.addEventListener('click', async () => {
      const discountCode = input.value.trim();

      if (!discountCode) return;

      button.disabled = true;

      try {
        console.log('Applying discount:', discountCode);

        // Save discount code
        localStorage.setItem('storedDiscount', discountCode);

        // Apply Shopify discount
        await fetch(
          `/discount/${encodeURIComponent(discountCode)}`,
          {
            method: 'GET',
            credentials: 'include',
            redirect: 'follow'
          }
        );

        // Get updated cart
        const cartResponse = await fetch('/cart.js', {
          credentials: 'include',
          headers: {
            Accept: 'application/json'
          }
        });

        const cart = await cartResponse.json();

        console.log('Updated cart:', cart);
        console.log('Original total:', cart.original_total_price);
        console.log('Final total:', cart.total_price);
        console.log(
          'Discounts:',
          cart.cart_level_discount_applications
        );

        // Close popup
        const popup = this.closest('.popup-toolDown');

        if (popup) {
          popup.classList.remove('show');
        }

        const previewCart = document.querySelector('.previewCart');

        if (previewCart) {
          previewCart.classList.remove('active-tool');
        }

        // Refresh existing theme cart
        if (
          window.sharedFunctions &&
          typeof window.sharedFunctions.updateSidebarCart === 'function'
        ) {
          window.sharedFunctions.updateSidebarCart(cart);
        }

      } catch (error) {
        console.error('Discount error:', error);
      } finally {
        button.disabled = false;
      }
    });
  }
}

if (!customElements.get('coupon-code')) {
  customElements.define('coupon-code', CouponCode);
}

window.updateCartDrawerProvinces = function(countrySelect) {

  var provinceSelect =
    document.getElementById('address_province');

  var provinceContainer =
    document.getElementById('address_province_container');

  if (!countrySelect || !provinceSelect) {
    console.log('Country/province select not found');
    return;
  }

  var selectedOption =
    countrySelect.options[countrySelect.selectedIndex];

  if (!selectedOption) {
    return;
  }

  var provinces =
    selectedOption.getAttribute('data-provinces');

  console.log('Selected country:', countrySelect.value);
  console.log('Province data:', provinces);

  provinceSelect.innerHTML =
    '<option value="">Select state</option>';

  if (!provinces || provinces === '[]') {

    provinceSelect.disabled = true;

    if (provinceContainer) {
      provinceContainer.style.display = 'none';
    }

    return;
  }

  try {

    var provinceData = JSON.parse(provinces);

    provinceData.forEach(function(province) {

      var option =
        document.createElement('option');

      option.value = province[0];
      option.textContent = province[1];

      provinceSelect.appendChild(option);

    });

    provinceSelect.disabled = false;

    if (provinceContainer) {
      provinceContainer.style.display = 'block';
    }

    console.log(
      'States loaded:',
      provinceData.length
    );

  } catch (error) {

    console.error(
      'Province error:',
      error
    );

  }
};

document.addEventListener('change', function(event) {

  if (
    event.target &&
    event.target.id === 'address_country'
  ) {

    window.updateCartDrawerProvinces(
      event.target
    );

  }

});


window.initOldShippingCalculator = function() {

  console.log('Initializing old Halo shipping calculator');

  if (
    !window.Shopify ||
    !Shopify.Cart ||
    !Shopify.Cart.ShippingCalculator
  ) {

    console.error(
      'Shopify.Cart.ShippingCalculator is NOT available'
    );

    return;
  }

  if (!window.cartShippingSettings) {

    console.error(
      'cartShippingSettings is NOT available'
    );

    return;
  }

  Shopify.Cart.ShippingCalculator.show({

    submitButton:
      window.cartShippingSettings.submitButton,

    submitButtonDisabled:
      window.cartShippingSettings.submitButtonDisabled,

    customerIsLoggedIn:
      window.cartShippingSettings.customerIsLoggedIn,

    moneyFormat:
      window.cartShippingSettings.moneyFormat

  });

  console.log(
    'Old Halo shipping calculator initialized'
  );
};